import React from 'react'
import AiImage from '../../../assets/bot.png'
import { useNavigate, useLocation, Link } from "react-router-dom";



export default function AiModule() {
  return (
    <Link to={"/farmer-dashboard/ai"} className='ai-button' >
        <img src={AiImage} alt="" />
      
    </Link>
  )
}
